<!--
 * @Author: xing.huang
 * @Date: 2021-02-02 16:20:10
 * @LastEditTime: 2021-04-02 11:23:24
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\report\CustomReport\index.vue
 * @
-->
<template>
    <div style="width:100%;heigh:100%;" class="custom-report">
        <div class="table_searchbar">
            <el-row :gutter="20">
                <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title">报表类型：</span>
                        <el-select style="max-width:180px"  clearable     size="small" v-model="searchForm.propertyType"  placeholder="报表类型"    >
                            <el-option v-for="item in propertyTypeOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title">报表名称：</span>
                        <el-input style="max-width:180px" size="small" v-model="searchForm.reportDataName" placeholder="报表名称"></el-input>
                    </div>
                </el-col>
                <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title">创建时间：</span>
                        <el-date-picker style="max-width:214px" v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="(24-span*3)">
                    <div style="text-align:right">
                        <el-button size='mini' icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size='mini' icon="el-icon-refresh"  @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="table_common_operbar">
            <el-row>
                <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增</el-button>
            </el-row>
        </div>
        <el-table :data="tableData" stripe style="width: 100%" class="CustomReportTable">
            <el-table-column type="index" label="序号" width="50" ></el-table-column>
            <el-table-column prop="propertyType" :formatter='parsePropertyType' label="报表类型" min-width="120" ></el-table-column>
            <el-table-column prop="reportDataName" label="报表名称" min-width="110" ></el-table-column>
            <el-table-column prop="createUserName"  label="创建人" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="lastModifyUserName" label="最后修改人" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="gmtCreate"  label="创建时间" min-width="100" :formatter='$commonUtil.changeToDate'  show-overflow-tooltip></el-table-column>
            <el-table-column prop="gmtModified"  label="更新时间" min-width="100" :formatter='$commonUtil.changeToDate'  show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" fixed="right" width="240">
                <template slot-scope="scope">
                    <el-button v-if='(scope.row.permissionTypeList||[]).includes(0)'  type="text" size="small" @click="showDetail(scope.row)">查询</el-button>
                    <el-button v-if='(scope.row.permissionTypeList||[]).includes(1)' @click="showEditDialog(scope.row)" type="text" size="small" >编辑</el-button>
                    <el-button v-if='(scope.row.permissionTypeList||[]).includes(2)' @click="deleteCustomReport(scope.row)" type="text" size="small" >删除</el-button>
                    <el-button @click="showUserRoleList(scope.row)" type="text" size="small" >配置权限</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page" v-if="tableData.length > 0">
            <div class="total_page"><span> 共{{tableTotalPage}}条 </span></div>
            <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                <el-pagination background @size-change="sizeChange" layout=" sizes, prev, pager, next, jumper"
                :page-count="tableTotalPage"
                :page-sizes="[10, 20, 30, 50,100]"
                :page-size.sync="pageSize"
                :total="tableTotalPage" @current-change="pageChange" :current-page.sync="tableCurrentPage"></el-pagination>
            </div>
        </div>

        <!--权限配置开始 -->
        <el-dialog title="权限配置" @close='closeUserRole' style="font-size:24px; cololr:#ccc;font-family: NotoSansHans-Regula" :close-on-click-modal="false" :visible="showUserRole" :width="W?'40%':'54%'" center>
            <div >
                <el-button  type="primary"  size="mini" @click="addItem" style="margin-top:-20px;margin-bottom: 10px">新增</el-button>
                <el-table :data="userRoleList" stripe style="width: 100%" border :maxHeight="474">
                    <el-table-column type="index"  width="50" label="序号"></el-table-column>
                    <el-table-column prop="userId" label="姓名" min-width="70">
                        <template slot-scope="scope">
                            <el-select    clearable     size="small" v-model="scope.row.userId"  placeholder="姓名"    >
                                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column  label="权限" min-width="130">
                        <template slot-scope="scope">
                            <el-checkbox-group v-model="scope.row.permissionTypeList" style="display: inline-block;" >
                                <el-checkbox  :label="0">查看</el-checkbox>
                                <el-checkbox  :label="1">编辑</el-checkbox>
                                <el-checkbox  :label="2">删除</el-checkbox>
                            </el-checkbox-group>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" fixed="right" width="50">
                        <template slot-scope="scope">
                            <div class="delete" type="primary" @click="deleteItem(scope.$index)"></div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer" style="margin-top:30px; ">
                <el-button  type="primary"  size="mini" @click="updataUserRoleList" >更 新</el-button>
                <el-button  @click="closeUserRole">取 消</el-button>
            </span>
        </el-dialog>
        <!--权限配置结束-->
       
    </div>
</template>

<script>
export default {
    name: 'CustomReport',
	data () {
        let that = this
        return {
            propertyTypeOptions:[  // 0-生产报表 1-质检报表 2-仓库报表 3-计划排程
                {value:0,name:'生产报表'},
                {value:1,name:'质检报表'},
                {value:2,name:'仓库报表'},
                {value:3,name:'计划排程'},
            ],
            searchForm:{
                dateRange:[],
                reportDataName: '',
                propertyType:null
            },
            beginDate:'',
            endDate:'',
            userRoleList:[],
            showUserRole:false,
            positionList:[],
            loading:false,
            statusOptions:[  //0确认 1暂定使用 2已报废
                {id:0,value:0,label:'确认'},
                {id:1,value:1,label:'暂停使用'},
                {id:2,value:2,label:'已报废'},
            ],

            fristLoad:false,
            isChange:false,
            showType:false,
            exportInfo:{
                success:0,
                fail:0,
                url:null,
                total:0
            },
            exportDialogVisible:false,
            W:false,
            viewData:{
                inow:0,
                recordList:[]
            },
            toolTypeLoading: false,
            toolTypeOptions: [],
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            
            addForm:{
                reportDataConfigId:null,
                dataList:[],
            },
            viewForm : {
                toolId:'',
                toolName:'',
                specification:'',
                serialNumber:'',
                osType:'',
                vendor:'',
                manufacturer:'',
                productionDate:'',
                useDate:'',
                moldCountRecordList:[]
            },
            pageSize:10,
            tableData:[{},{}],
            tableCurrentPage:1,
            tableTotalPage:100,
            addDialogVisible:false,
            editDialogVisible:false,
            viewDialogVisible:false,
            recordList:[],
			token: localStorage.getItem("token"),
            oldData:[],
            toolList:[],
            userList:[],
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted:async function(){
        
        this.initTable();
        this.loadUserList()
        let end = new Date().getTime()
        this.endDate = commonUtils.timestampToDate(end,true)
        this.beginDate = commonUtils.timestampToDate(end-7*24*60*60*1000,true)
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        
    },
    deactivated:function(){
        console.log("deactivated");
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    methods:{
        showDetail(row){
            let {id,reportDataName} = row
            this.$router.push({path: `/Report/ViewCustomReport`,query:{id,reportDataName}})
        },

        loadUserList(){
            this.$RequestUtil.get({
                url: '/api/user/listUser',
                params: {},
                success:res=>{
                    this.userList = res.data
                }
            })
        },
        async loadUserRoleList(reportDataConfigId){
            let {data,msg,code,message} = await this.$RequestUtil.getAsync({url: '/api/customTable/getUserPermission',params: {reportDataConfigId},})
            if(code==0){
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        async updataUserRoleList(id){
            this.addForm.dataList = this.userRoleList
            let err_msg = ''
            this.userRoleList.forEach((item,index)=>{
                if(item.permissionTypeList.length==0){
                    err_msg = `序号为${index+1}的权限不能为空,请至少选择一个权限`
                }
                if(!item.userId){
                    err_msg = `序号为${index+1}的用户不能为空,请选择用户`
                }
            })
            if(err_msg){
                this.$message.error(err_msg)
                return
            }
            this.$RequestUtil.post({
                url: '/api/customTable/updateUserPermission',
                params: {...this.addForm},
                success:res=>{
                    if(res.code==0){
                        this.$message.success('更新成功')
                        this.closeUserRole()
                    }else{
                        this.$message.error(res.msg||res.message)
                    }
                }
            })
        },

        async showUserRoleList(row){
            this.userRoleList = await this.loadUserRoleList(row.id)
            this.addForm.reportDataConfigId = row.id
            this.showUserRole = true
        },

        closeUserRole(){
            this.showUserRole = false
            this.userRoleList = []
        },

        deleteItem(index){
           this.userRoleList.splice(index, 1);
        },

        addItem(){
            this.userRoleList.push({
                permissionTypeList:[0]
            })
        },
       
        sizeChange(ev){
            this.pageSize = ev
            this.tableCurrentPage = 1
            this.search(1);
        },

        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },

        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.propertyType = null;
            form.reportDataName = '';
            form.dateRange = [];
        },

        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                  propertyType:null,
                  reportDataName: '',
                  dateRange: []
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            let createDateBegin,createDateEnd
            if(temp.dateRange&&temp.dateRange.length==2){
                createDateBegin = temp.dateRange[0]
                createDateEnd = temp.dateRange[0]
            }
            delete temp.dateRange
            this.$RequestUtil.get({
                url: '/api/customTable/listReportData',
                type:'sync',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:this.pageSize,
                    propertyType:temp.propertyType,
                    reportDataName: temp.reportDataName,
                    createDateBegin,
                    createDateEnd
                },
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                        this.$message.error(res.msg||res.message);

                    }
                }
            });
        },

        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },

        initTable:function(){
            this.search();
        },

        addWindowShow:function(){
            this.$router.push({path: "/Report/CustomReportAddDialog"})
        },

        updateCustomReport:function(){
           

        },
        
        showEditDialog:async function(rowData){
            this.$router.push({path: `/Report/CustomReportEditDialog`,query:{id:rowData.id}})
        },

        viewCustomReport: async function(rowData){
            
        },

        deleteCustomReport:function(rowData) {
            let message = '此操作将删除自定义报表，是否继续';
            this.$confirm(message, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/customTable/deleteReportData',
                    type:'sync',
                    params: {
                        id:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.initTable()
                        }else {
                          this.$message({
                            type: 'error',
                            message: res.msg||res.message
                          });
                        }
                    }
                });
            });
        },

    

        
        parsePropertyType:function(val){
            return (this.propertyTypeOptions.find(item=>item.value == val.propertyType)||{}).name
        },

        parseDate:function(rowData){
            if(rowData.useDate != null){
                let dateString = commonUtils.timestampToDate(rowData.useDate,true);
                return dateString;
            }
        },

        parseMoldTime(rowData){
            if(rowData.useTime != null){
                let dateString = commonUtils.timestampToDate(rowData.useTime,true);
                return dateString;
            }
        },
        
    },
    watch: {
        $route: function(to, from) {
           
            if(from.path=='/Report/CustomReportAddDialog'||from.path=='/Report/CustomReportEditDialog'){
                this.initTable()
            }
        }
    }
}
</script>

<style>
  .custom-report .el-scrollbar__wrap{
        overflow-x: hidden;
        max-height:500px;
        height: auto;
        overflow-x: hidden;
        margin-bottom: 0px !important;
    }
  .import_upload>.el-upload-list{
      display: none;
   }
  .custom-report .el-date-editor.el-input, .custom-report .el-date-editor.el-input__inner{
      width:356px
  }
  /* .deviceTable .cell{
    padding-right:0px;
     overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
} */
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
.custom-report .el-timeline-item__node--large{

    left: -6px;
    width: 22px;
    height: 22px;

}
 .select_width{
	width: 180px;
}
.custom-report .el-menu-item.is-active{
    color: #303133;
}
</style>
<style scoped>


.table_searchbar .title11{
    color:  #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 10px;
    margin-bottom: 20px;
}

.page{
    display: flex;
    justify-content: flex-end;
}

.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
.history{
    display: inline-block;
    font-weight: bold;
}
.delete {
    width: 18px;
    height: 19px;
    background-image: url("../../../../static/img/del.png");
    cursor: pointer;
    background-repeat: no-repeat;
}
.delete:hover {
    background-image: url("../../../../static/img/del-hover.png");
    background-repeat: no-repeat;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.key{
    font-size: 16px;
    color:#c0c4cc;
    font-family: NotoSansHans-Regula;
    padding-right:10px;
    line-height:3
}
.addForm .value{
    display: inline-block;
    max-width: 180px;
}
.addForm .title{
    width: 70px;
    text-align: right;
    display:inline-block
}
.value{
    font-size:16px;
    color:#999;
    font-family: NotoSansHans-Regula;

    line-height: 3;
}

</style>





// WEBPACK FOOTER //
// src/views/report/CustomReport/index.vue